import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { TransferComponent } from "Components/Transfer/TransferComponent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

export const TransferPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Transfer)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
      isBottomMenuHidden
    >
      <StyledPageWrapper>
        <TransferComponent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default TransferPage;
